import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import { environment } from '../../../../../environments/environment';
import { HttpClient } from "@angular/common/http";

@Injectable()
export class VendorTaxClearanceService {
    private avrcsBackendUrl = environment.baseUrl.avrcs_2.backend;
    private _url = `${this.avrcsBackendUrl}api/tax-clearance`;
    private urlShow = `${this.avrcsBackendUrl}api/vendors-show`;

    constructor(private http: HttpClient) {}

    index(tin: any): Observable<any> {
        return this.http.get(`${this._url}?tin=${tin}`);
    }

    show(id, isLog): Observable<any> {
        return this.http.get(`${this._url}/${id}?is_log=${isLog}`);
    }

    logs(id): Observable<any> {
        return this.http.get(`${this._url}/logs?sigtas_tax_clearance_id=${id}`);
    }

    showVendor(id: any): Observable<any> {
        return this.http.get(this.urlShow + '/' + id);
    }

}
